import PageLayout from '../../components/PageLayout'

import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import getPatrimony from 'store/patrimony/patrimonyActions'
import { PatrimonyToolbar } from './PatrimonyToolbar'
import { PatrimonyList } from './PatrimonyList'
import { PatrimonyActionTypes } from 'store/patrimony/patrimonyTypes'
import { PatrimonyDetails } from './PatrimonyDestails'
import PatrimonyPlaceholder from './PatrimonyPlaceholder'
import { StoreState } from 'store'

export default function Patrimony() {
  const dispatch = useDispatch()

  const { isEditing, selectIndex } = useSelector((state: StoreState) => ({
    isEditing: state.patrimonyState.isEditing,
    selectIndex: state.patrimonyState.selectedIndex,
  }))

  const onMountPage = () => dispatch(getPatrimony())
  const onUnmountPage = () =>
    dispatch({ type: PatrimonyActionTypes.CLEAR_PATRIMONY })

  return (
    <PageLayout
      toolbar={<PatrimonyToolbar />}
      list={<PatrimonyList />}
      details={<PatrimonyDetails key={String(selectIndex)} />}
      detailsPlaceholder={<PatrimonyPlaceholder />}
      hideDetails={!isEditing}
      onMountPage={onMountPage}
      onUnmountPage={onUnmountPage}
    />
  )
}
